import React, { FC, useEffect, useRef, useState } from 'react'

import { cx, css } from '@linaria/core'
import { styled } from '@linaria/react'

import { GQLPublicTravelAtlasVisitedCountry } from 'generated-graphql/graphql'

import { More } from '../Typography/More/More'

const imagesContext = require.context(
  '/src/common/components/designSystem/svg/flags',
  true,
  /^\.\/.*\.svg$/
)

const heightRowFlag = 40

export const ListCountriesFlag: FC<{
  list: GQLPublicTravelAtlasVisitedCountry[]
}> = ({ list }) => {
  const parentRef = useRef<HTMLUListElement>(null)
  const [isClamped, setIsClamped] = useState<boolean>(false)

  const handleClickMore = () => {
    setIsClamped(false)
  }

  const checkClamp = () => {
    if (parentRef.current) {
      const { clientHeight } = parentRef.current
      setIsClamped(clientHeight > heightRowFlag)
    }
  }

  useEffect(() => {
    checkClamp()
  }, [])

  return (
    <Parent>
      <List
        ref={parentRef}
        className={cx(isClamped && heightCss)}
        data-name="travel-list"
      >
        {list.map(({ country: { code, name } }) => {
          try {
            const flag = imagesContext(`./${code.toLowerCase()}.svg`)

            return (
              <li key={code} data-name={`country-${code}`}>
                <Image
                  src={flag}
                  width={heightRowFlag}
                  height={heightRowFlag}
                />
              </li>
            )
          } catch (error) {
            console.error(`Не найден флаг для ${code} - ${name}`)

            return null
          }
        })}
      </List>
      {isClamped && (
        <Footer>
          <More onClick={handleClickMore} data-name="travel-list-more" />
        </Footer>
      )}
    </Parent>
  )
}

const Parent = styled.div`
  display: grid;
  gap: var(--spacing-24px);
  grid-gap: var(--spacing-24px);
`

const heightCss = css`
  height: ${heightRowFlag}px;
  overflow: hidden;
`

const List = styled.ul`
  display: grid;
  grid-template-columns: repeat(auto-fill, 40px);
  gap: var(--spacing-8px);
  grid-gap: var(--spacing-8px);
`

const Image = styled.img`
  vertical-align: top;
`

const Footer = styled.div`
  display: flex;
  justify-content: center;
`
